import React from "react";
import { Link } from "react-router-dom";
import "./Cards.css";

const Cards = ({ img, name, id, capital }) => {
  return (
    <div className="card" data-aos="flip-left" data-aos-duration="1000">
      <div className="card-img">
        <Link to={`detail/${id}`}>
          <img src={img} alt={name} height={200} width={300} />
        </Link>
      </div>
      <div className="card-title">
        <h3>{name}</h3>
        <p>({id})</p>
      </div>
      <div className="card-info">
        <h5>{capital}</h5>
      </div>
    </div>
  );
};

export default Cards;
